import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  CreateEstimateInput,
  CreateEstimateMutation as CreateEstimateMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const CreateEstimateMutation = graphql(`
  mutation CreateEstimate($input: CreateEstimateInput!) {
    createEstimate(input: $input) {
      id
    }
  }
`);

const useCreateEstimate = (
  options?: UseMutationOptions<
    CreateEstimateMutationResult,
    Error,
    CreateEstimateInput
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CreateEstimateMutation, { input });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.estimates(variables.projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useCreateEstimate;
